// ========================================
// Category Dashboards — RRHH Panel
// ========================================

Object.assign(window.CategoryDashboards, {
    renderRRHH() {
        const professors = typeof DataManager !== 'undefined' ? DataManager.getAll(DataManager.KEYS.PROFESSORS) : [];

        // ── En activo y próximas altas ──
        const todayStr = new Date().toISOString().split('T')[0];
        
        // Profesores en activo: deben tener fecha de alta (hireDate <= hoy) y no haber causado baja (terminationDate >= hoy o sin baja)
        const activeProfs = professors.filter(p => {
            if (!p.hireDate) return false;
            const hDate = String(p.hireDate).slice(0, 10);
            const isHired = hDate <= todayStr;
            const isNotTerminated = !p.terminationDate || String(p.terminationDate).slice(0, 10) >= todayStr;
            return isHired && isNotTerminated;
        });

        // Próximas altas: profesores con fecha de alta futura
        const upcomingHires = professors.filter(p => {
            if (!p.hireDate) return false;
            const hDate = String(p.hireDate).slice(0, 10);
            return hDate > todayStr;
        }).sort((a, b) => String(a.hireDate || '').localeCompare(String(b.hireDate || '')));

        const docs = typeof DataManager !== 'undefined' ? DataManager.getAll(DataManager.KEYS.JUSTIFICANTES) : [];

        // ── Nóminas del mes: el último mes que ya toca según la regla del día 28 (hasta el 27 el
        // mes anterior, desde el 28 el mes en curso), con las mismas cuentas que Nóminas: clases
        // ese mes o un contrato que lo cubre. Si sus clases aún no están cargadas, se repinta al llegar.
        const now2 = new Date();
        const payrollHistory = (typeof FileStorage !== 'undefined' && FileStorage.read) ? (FileStorage.read('ecpv_payroll_history') || []) : [];
        const dueMonth = typeof DashboardView !== 'undefined' ? DashboardView._payrollDueMonths(now2).slice(-1)[0] : { month: now2.getMonth() + 1, year: now2.getFullYear() };
        if (typeof DashboardView !== 'undefined') DashboardView._needPayrollMonths(() => { if (App.currentView === 'rrhh') this.reRenderDashboard('rrhh'); });
        const currentMonthName = new Date(dueMonth.year, dueMonth.month - 1, 1).toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
        const expectedIds = typeof NominasUpload !== 'undefined' ? NominasUpload.dueIds(dueMonth.month, dueMonth.year) : new Set();
        const uploadedThisMonth = new Set(payrollHistory.filter(h => Number(h.monthIndex) === dueMonth.month && String(h.year) === String(dueMonth.year)).map(h => h.professorId));

        const nominasExpectedCount = expectedIds.size;
        const nominasUploadedCount = [...expectedIds].filter(id => uploadedThisMonth.has(id)).length;
        const nominasPendingCount = nominasExpectedCount - nominasUploadedCount;
        const nominasPct = nominasExpectedCount > 0 ? Math.round((nominasUploadedCount / nominasExpectedCount) * 100) : 100;

        // ── Antigüedad de la plantilla activa (Nuevos <1 año / Consolidados 1+ año) ──
        const oneYearAgoStr = new Date(now2.getFullYear() - 1, now2.getMonth(), now2.getDate()).toISOString().split('T')[0];
        // Seniority counts from the first contract.
        const veteranProfsCount = activeProfs.filter(p => (StaffPay.contractsOf(p)[0]?.startDate || '9999') <= oneYearAgoStr).length;
        const newProfsCount = activeProfs.length - veteranProfsCount;
        const veteranPct = activeProfs.length > 0 ? Math.round((veteranProfsCount / activeProfs.length) * 100) : 0;
        const newPct = activeProfs.length > 0 ? 100 - veteranPct : 0;

        const isEditMode = this.isEditMode('rrhh');
        const widgetsConfig = this.getWidgetsConfig('rrhh');

        const ctx = {
            professors, activeProfs, upcomingHires,
            nominasExpectedCount, nominasUploadedCount, nominasPendingCount, nominasPct, currentMonthName,
            veteranProfsCount, newProfsCount, veteranPct, newPct,
            ...this.rrhhPanelData(professors, activeProfs, docs, payrollHistory, todayStr)
        };
        this._lastRrhhCtx = ctx;

        const today = new Date().toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
        const links = [['profesores', 'fa-user-tie', 'Profesores'], ['nominas', 'fa-file-invoice-dollar', 'Nóminas'], ['justificantes', 'fa-file-medical', 'Justificantes'],
            ['tutorias-admin', 'fa-calendar-check', 'Tutorías'], ['documentos', 'fa-folder-open', 'Documentos']]
            .filter(([view]) => typeof RolePermissions === 'undefined' || RolePermissions.canView(view));

        return `
            <div class="dnr-proposal" style="width: 100%; padding: 0.75rem 1.5rem 1rem 1.5rem; box-sizing: border-box;">
                <div class="rp-head">
                    <div>
                        <div class="rp-date">${Utils.sanitizeHTML(today)}</div>
                        <h1 class="rp-title">Personal y RRHH</h1>
                    </div>
                    <div class="rp-links">
                        ${links.map(([view, icon, label]) => `<button type="button" class="rp-link" ${UIEvents.attr("click", function(event,captured){App.navigate(String(captured[0]));}, [view])}><i class="fas ${icon}" aria-hidden="true"></i> ${label}</button>`).join('')}
                        <button id="btn-cog-rrhh" class="dnr-cog-btn rp-link" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.toggleWidgetDrawer('rrhh');}, [])} title="Configurar widgets" aria-label="Configurar el panel">
                            <i class="fas fa-cog" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div>
                    <div style="min-width: 0; display: flex; flex-direction: column; gap: 1.25rem; position: relative;">

                        <!-- Overlay backdrop -->
                        <div id="widget-drawer-overlay-rrhh" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.toggleWidgetDrawer('rrhh');}, [])} style="display:none; opacity:0; position:fixed; inset:0; background:rgba(15,23,42,0.35); backdrop-filter:blur(2px); z-index:1100; transition: opacity 0.22s var(--dnr-ease-out);"></div>

                        <!-- Side Drawer -->
                        <div id="widget-drawer-rrhh" style="position:fixed; top:0; right:0; height:100vh; width:560px; background:var(--dnr-surface); box-shadow:-4px 0 32px rgba(0,0,0,0.14); z-index:1200; transform:translateX(100%); transition:transform 0.32s var(--dnr-ease-drawer); display:flex; flex-direction:column; font-family:inherit; visibility:hidden;">
                            <div style="padding:1.25rem 1.5rem; border-bottom:1px solid var(--dnr-line); display:flex; align-items:center; justify-content:space-between; flex-shrink:0;">
                                <div>
                                    <div style="font-size:1.05rem; font-weight:800; color:var(--dnr-ink); display:flex; align-items:center; gap:8px;">
                                        <i class="fas fa-th-large" style="color:var(--dnr-teal-600);"></i> Configuración del Panel
                                    </div>
                                    <div style="font-size:0.775rem; color:var(--dnr-ink-mute); margin-top:3px;">Personaliza qué widgets ves y cómo se organizan</div>
                                </div>
                                <button class="dnr-icon-btn" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.toggleWidgetDrawer('rrhh');}, [])} style="background:none; border:none; cursor:pointer; color:var(--dnr-ink-faint); padding:6px; border-radius:8px;" title="Cerrar">
                                    <i class="fas fa-times" style="font-size:1.1rem;"></i>
                                </button>
                            </div>

                            <div style="flex:1; overflow-y:auto; padding:1.25rem 1.5rem;">
                                <div style="margin-bottom:1.25rem;">
                                    <div style="font-size:0.7rem; font-weight:800; text-transform:uppercase; color:var(--dnr-ink-faint); letter-spacing:0.06em; margin-bottom:0.75rem;">Disposición</div>
                                    <div style="background:var(--dnr-surface-sunken); border:1px solid var(--dnr-line); border-radius:12px; padding:1rem 1.1rem; display:flex; align-items:flex-start; justify-content:space-between; gap:1rem;">
                                        <div style="flex:1;">
                                            <div style="font-size:0.875rem; font-weight:700; color:var(--dnr-ink);">Modo edición</div>
                                            <div style="font-size:0.775rem; color:var(--dnr-ink-mute); margin-top:3px; line-height:1.45;">Arrastra las tarjetas para reordenarlas y ajusta el ancho de cada widget (1, 2 o 3 columnas).</div>
                                        </div>
                                        <button id="btn-edit-toggle-rrhh" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.toggleEditMode('rrhh');}, [])} style="flex-shrink:0; background:${isEditMode ? '#ef4444' : '#0d9488'}; color:white; border:none; border-radius:8px; padding:0.5rem 1rem; font-size:0.8rem; font-weight:700; cursor:pointer; display:flex; align-items:center; gap:5px; white-space:nowrap;">
                                            <i class="fas ${isEditMode ? 'fa-check-circle' : 'fa-edit'}"></i>
                                            ${isEditMode ? 'Finalizar' : 'Editar'}
                                        </button>
                                    </div>
                                </div>

                                <div>
                                    <div style="font-size:0.7rem; font-weight:800; text-transform:uppercase; color:var(--dnr-ink-faint); letter-spacing:0.06em; margin-bottom:0.75rem;">Widgets disponibles</div>
                                    ${widgetsConfig.map((w, i) => `
                                    <div style="border-bottom:${i < widgetsConfig.length - 1 ? '1px solid var(--dnr-line)' : 'none'}; padding:0.85rem 0; display:flex; align-items:flex-start; gap:0.85rem;">
                                        <div style="flex-shrink:0; margin-top:2px;">
                                            <label style="position:relative; display:inline-block; width:36px; height:20px; cursor:pointer;">
                                                <input type="checkbox" ${w.visible ? 'checked' : ''} ${UIEvents.attr("change", function(event,captured){CategoryDashboards.toggleWidgetVisibility('rrhh',String(captured[0]));}, [w.id])} style="opacity:0; width:0; height:0; position:absolute;">
                                                <span style="position:absolute; inset:0; background:${w.visible ? '#0d9488' : '#cbd5e1'}; border-radius:20px; transition:background 0.2s;" id="toggle-track-${Utils.sanitizeHTML(w.id)}"></span>
                                                <span style="position:absolute; top:3px; left:${w.visible ? '19px' : '3px'}; width:14px; height:14px; background:white; border-radius:50%; transition:left 0.2s; box-shadow:0 1px 3px rgba(0,0,0,0.2);" id="toggle-thumb-${Utils.sanitizeHTML(w.id)}"></span>
                                            </label>
                                        </div>
                                        <div style="flex:1; min-width:0;">
                                            <div style="font-size:0.875rem; font-weight:700; color:${w.visible ? 'var(--dnr-ink)' : 'var(--dnr-ink-faint)'}; margin-bottom:2px;">${Utils.sanitizeHTML(w.name)}</div>
                                            <div style="font-size:0.775rem; color:var(--dnr-ink-mute); line-height:1.45; margin-bottom:0.5rem;">${CategoryDashboards._widgetDescriptions[w.id] || 'Widget del panel de Personal y RRHH.'}</div>
                                            <div style="display:${w.visible ? 'flex' : 'none'}; align-items:center; gap:4px;" id="span-selector-${Utils.sanitizeHTML(w.id)}">
                                                <span style="font-size:0.7rem; color:var(--dnr-ink-faint); font-weight:700; margin-right:4px;">Ancho:</span>
                                                ${[1, 2, 3].map(s => `<button type="button" class="span-btn" data-span="${s}" ${UIEvents.attr("click", function(event,captured){CategoryDashboards.setWidgetSpan('rrhh',String(captured[0]),captured[1]);}, [w.id, s])} style="padding:2px 8px; font-size:0.7rem; border-radius:6px; border:1px solid ${w.span === s ? '#0d9488' : '#e2e8f0'}; background:${w.span === s ? '#0d9488' : 'white'}; color:${w.span === s ? 'white' : '#64748b'}; font-weight:700; cursor:pointer;">${s}${s === 1 ? ' col' : ' cols'}</button>`).join('')}
                                            </div>
                                        </div>
                                        <span id="dropdown-span-${Utils.sanitizeHTML(w.id)}" style="display:none;">${w.span}</span>
                                    </div>
                                    `).join('')}
                                </div>
                            </div>

                            <div style="padding:1rem 1.5rem; border-top:1px solid var(--dnr-line); background:var(--dnr-surface-sunken); flex-shrink:0;">
                                <button ${UIEvents.attr("click", function(event,captured){CategoryDashboards.resetWidgetConfig('rrhh');}, [])} style="width:100%; background:transparent; color:var(--dnr-ink-mute); border:1px solid var(--dnr-line); border-radius:10px; padding:0.55rem 1rem; font-size:0.8rem; font-weight:600; cursor:pointer; display:flex; align-items:center; justify-content:center; gap:6px;">
                                    <i class="fas fa-undo"></i> Restablecer valores por defecto
                                </button>
                            </div>
                        </div>

                        <div id="edit-banner-rrhh" style="display: ${isEditMode ? 'flex' : 'none'}; background: linear-gradient(135deg, var(--dnr-teal-900) 0%, var(--dnr-teal-700) 100%); color: white; border-radius: 14px; padding: 0.85rem 1.25rem; align-items: center; justify-content: space-between;">
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div style="width: 32px; height: 32px; border-radius: 50%; background: rgba(79,216,196,0.2); border: 1px solid var(--dnr-teal-400); display: flex; align-items: center; justify-content: center; color: var(--dnr-teal-400);">
                                    <i class="fas fa-arrows-alt"></i>
                                </div>
                                <div>
                                    <div style="font-weight: 800; font-size: 0.875rem;">Modo Personalización Activo</div>
                                    <div style="font-size: 0.775rem; color: var(--dnr-teal-100);">Arrastra las tarjetas para reordenarlas o usa los botones de cada tarjeta para cambiar su ancho.</div>
                                </div>
                            </div>
                            <button ${UIEvents.attr("click", function(event,captured){CategoryDashboards.toggleEditMode('rrhh');}, [])} style="background: var(--dnr-teal-600); color: white; border: none; border-radius: 8px; padding: 0.45rem 1.15rem; font-size: 0.825rem; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 6px;">
                                <i class="fas fa-check"></i> Guardar y Listo
                            </button>
                        </div>

                        <!-- Widgets Grid -->
                        <div id="widgets-grid-rrhh" class="dnr-widget-grid">
                            ${widgetsConfig.map((w, i) => this.renderRrhhWidget(w, isEditMode, ctx, i)).join('')}
                        </div>
                    </div>
                </div>
            </div>
        `;
    },

    /**
     * What the panel's newer widgets need (2026-10-20): absences (loaded on their own,
     * see rrhhLeaves), real payroll cost, last month's missing payslips, advisory notices,
     * upcoming hires/terminations, staff by pay type and recent justificantes.
     */
    rrhhPanelData(professors, activeProfs, docs, payrollHistory, todayStr) {
        const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const now = new Date(), nowKey = now.getFullYear() * 12 + now.getMonth() + 1;
        const byId = new Map(professors.map(p => [p.id, p]));
        const name = p => `${p.firstName || ''} ${p.lastName || ''}`.trim() || 'Persona';
        const isFixed = p => typeof StaffPay !== 'undefined' && StaffPay.isFixed(p);
        const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };

        // Coste empresa of this course, month by month, split into fixed salaries and hourly pay.
        const costCourse = now.getMonth() + 1 >= 9 ? now.getFullYear() : now.getFullYear() - 1;
        const costByMonth = [9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8].map(month => {
            const year = month >= 9 ? costCourse : costCourse + 1, key = year * 12 + month;
            const cell = { label: MONTHS[month - 1], fixed: 0, hourly: 0, when: key < nowKey ? -1 : key === nowKey ? 0 : 1 };
            for (const h of payrollHistory) {
                if (Number(h.monthIndex) !== month || String(h.year) !== String(year) || h.companyCost == null) continue;
                // With the settlement (finiquito) paid that month, if any.
                cell[isFixed(byId.get(h.professorId) || {}) ? 'fixed' : 'hourly'] += (Number(h.companyCost) || 0) + (h.settlementFilePath ? Number(h.settlementCost) || 0 : 0);
            }
            return cell;
        });
        // The latest month with payslips (any course).
        const latest = payrollHistory.reduce((best, h) => Math.max(best, Number(h.year) * 12 + Number(h.monthIndex)), 0);
        const latestRows = latest ? payrollHistory.filter(h => Number(h.year) * 12 + Number(h.monthIndex) === latest) : [];
        const lastCost = latest ? { label: MONTHS[(latest - 1) % 12], count: latestRows.length, missing: latestRows.filter(h => h.companyCost == null).length,
            cost: latestRows.reduce((s, h) => s + (Number(h.companyCost) || 0) + (h.settlementFilePath ? Number(h.settlementCost) || 0 : 0), 0) } : null;

        // Payslips still missing from the months already due: a month's become due on its 28th, so
        // until the 27th it is last month and from the 28th this month too (same rule as the Inicio).
        const dueMonths = typeof DashboardView !== 'undefined' ? DashboardView._payrollDueMonths(now) : [];
        const lateByMonth = typeof NominasUpload === 'undefined' ? [] : dueMonths.map(({ month, year }) => {
            const uploaded = new Set(NominasUpload.payslipsOf(month, year, payrollHistory).map(h => h.professorId));
            return { month, names: [...NominasUpload.dueIds(month, year)].filter(id => !uploaded.has(id) && byId.has(id)).map(id => name(byId.get(id))).sort() };
        });
        const lateMonths = lateByMonth.filter(m => m.names.length);
        // One entry per payslip; with two months late, each name says which.
        const missing = lateMonths.flatMap(m => lateMonths.length > 1 ? m.names.map(n => `${n} (${MONTHS[m.month - 1].toLowerCase()})`) : m.names);
        const payrollMonthName = (lateMonths.length ? lateMonths : dueMonths.slice(-1)).map(({ month }) => MONTHS[month - 1].toLowerCase()).join(' y ');

        // Every contract counts (a person can be hired several times): hires from two months ago
        // whose advisory notice is still unticked; hires and terminations ahead.
        const contracts = professors.flatMap(p => StaffPay.contractsOf(p).map(c => ({ p, c })));
        const advisoryPending = [...new Map(contracts.filter(({ c }) => !c.freelance && !c.advisoryNotified && c.startDate >= addDays(todayStr, -60) && (!c.endDate || c.endDate >= todayStr))
            .map(({ p }) => [p.id, { id: p.id, name: name(p) }])).values()];
        const horizon = addDays(todayStr, 120);
        const moves = [
            ...contracts.filter(({ c }) => c.startDate >= todayStr && c.startDate <= horizon)
                .map(({ p, c }) => ({ id: p.id, name: name(p), kind: 'alta', date: c.startDate, advisoryPending: !c.freelance && !c.advisoryNotified, freelance: !!c.freelance })),
            ...contracts.filter(({ c }) => c.endDate && c.endDate >= todayStr && c.endDate <= horizon)
                .map(({ p, c }) => ({ id: p.id, name: name(p), kind: 'baja', date: c.endDate, advisoryPending: false }))
        ].sort((a, b) => a.date.localeCompare(b.date));

        const payTypes = { fixed: 0, hourly: 0, freelance: 0, noRate: 0 };
        for (const p of activeProfs) {
            if (!isFixed(p)) { payTypes[StaffPay.isFreelance(p) ? 'freelance' : 'hourly']++; if (!(Number(p.hourlyRate) > 0)) payTypes.noRate++; }
            else payTypes.fixed++;
        }

        const docDate = d => String(d.date || d.createdAt || '').slice(0, 10);
        const recentDocs = docs.slice().sort((a, b) => docDate(b).localeCompare(docDate(a))).slice(0, 5).map(d => ({
            name: d.professorName || d.studentName || 'Sin nombre', date: docDate(d), isNew: !d.reviewedAt,
            detail: `${d.professorId ? 'Personal' : 'Alumnado'}${d.type ? ` · ${String(d.type).toLowerCase()}` : ''}`
        }));

        // Monday to Friday of this week.
        const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - ((now.getDay() + 6) % 7));
        const week = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie'].map((label, i) => {
            const d = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + i);
            const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            return { label, iso, today: iso === todayStr };
        });

        return {
            costCourse, costByMonth, lastCost, payrollDue: { monthName: payrollMonthName, missing },
            advisoryPending, moves, payTypes, recentDocs, justificantesNew: docs.filter(d => !d.reviewedAt).length,
            week, leaves: this.rrhhLeaves(week[0].iso, addDays(week[0].iso, 6))
        };
    },

    /**
     * Pending requests and this week's approved absences (GET /api/staff-leaves/overview), only
     * for who manages staff; loaded once a minute at most and the panel redrawn when it arrives.
     */
    rrhhLeaves(from, to) {
        const canManage = AuthManager.isAdmin() || AuthManager.isRRHH() || AuthManager.hasModule('personal-laboral', 'manage');
        if (!canManage) return { pending: [], away: [] };
        const cached = this._rrhhLeaves;
        if (cached && cached.key === from && Date.now() - cached.at < 60000) return cached.data;
        if (!this._rrhhLeavesLoading) {
            this._rrhhLeavesLoading = fetch(`/api/staff-leaves/overview?from=${from}&to=${to}`, { cache: 'no-store' })
                .then(response => response.json().then(body => ({ ok: response.ok, body })))
                .then(({ ok, body }) => ok && body.success ? { pending: body.pending, away: body.away } : { error: true })
                .catch(() => ({ error: true }))
                .then(data => {
                    this._rrhhLeaves = { key: from, at: Date.now(), data };
                    this._rrhhLeavesLoading = null;
                    if (document.getElementById('widgets-grid-rrhh') && !this.isEditMode('rrhh')) this.reRenderDashboard('rrhh');
                });
        }
        return cached ? cached.data : null;
    },

    /** After approving or rejecting: load again and redraw. */
    refreshRrhhLeaves() {
        this._rrhhLeaves = null;
        this.reRenderDashboard('rrhh');
    },

    // Dispatch table: widget id -> function name under window.DashboardWidgets.rrhh
    _rrhhWidgetMap: {
        'kpi-plantilla': 'kpiTile',
        // Antes apuntaba a 'kpiTile', que no tiene ninguna rama para este id y caía
        // por defecto en la de "Justif. Aprobados" — el KPI de Nóminas mostraba en
        // pantalla "Justif. Aprobados: 0" y al pulsarlo llevaba a /justificantes.
        'kpi-nominas': 'nominasMes',
        'contratacion-donut': 'contratacionDonut',
        // Diseño del 2026-10-20 (propuesta F)
        'rrhh-pendientes': 'pendientes',
        'kpi-coste-mes': 'costeMes',
        'permisos-aprobar': 'permisosAprobar',
        'fuera-semana': 'fueraSemana',
        'coste-curso': 'costeCurso',
        'altas-bajas': 'altasBajas',
        'justificantes-recientes': 'justificantesRecientes',
        'plantilla-tipos': 'plantillaTipos'
    },

    renderRrhhWidget(w, isEditMode, ctx, i) {
        const span = w.span || 1;
        const controls = this.renderWidgetHeaderControls('rrhh', w.id, w.name, span, isEditMode);
        const displayStyle = w.visible ? 'flex' : 'none';

        const fnName = this._rrhhWidgetMap[w.id];
        const widgetFn = fnName && window.DashboardWidgets.rrhh[fnName];
        if (!widgetFn) return '';

        const html = widgetFn({ ...ctx, id: w.id, span, controls, displayStyle, isEditMode });
        return `<div style="display:contents; --dnr-i:${i || 0};">${html}</div>`;
    }
});
